import { render, staticRenderFns } from "./setMenu.vue?vue&type=template&id=7bccbc79"
import script from "./setMenu.vue?vue&type=script&lang=js"
export * from "./setMenu.vue?vue&type=script&lang=js"
import style0 from "./setMenu.vue?vue&type=style&index=0&id=7bccbc79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports